import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceAnimatedMenuRenderComponent } from './piece-animated-menu-render.component';
import { GetCategoryLinkPipe } from './pipes/piece-animated-menu.pipe';


export const pieceAnimatedMenuRenderModuleEntryComponents = [
  PieceAnimatedMenuRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: [
    ...pieceAnimatedMenuRenderModuleEntryComponents,
    GetCategoryLinkPipe
  ]
})
export class PieceAnimatedMenuRenderModule {}

export default pieceAnimatedMenuRenderModuleEntryComponents;
